import { ISchema, ISchemaChild } from "../Schema";
import { EntityNames } from "../../../../enums/EntityNames";
import { EntityViewTypes } from "../../../../enums/EntityViewTypes";
import { hasPermission } from "../../../../modules/auth/Permissions/PermissionModule";
import { PermissionConcerns, PermissionTypes } from "../../../../modules/auth/Permissions/PermissionStrings";

export const OperatorSettingsSchema: ISchema = {
    displayName: "Settings",
    props: [],

    children: [
        { 
            entityName: EntityNames.operators, 
            displayName: "Operators", 
            cantView: false, 
            viewType: EntityViewTypes.list, 
            canAdd: true, 
            enableFilters: true,
            permissionToView: ((ctx) => hasPermission(ctx.permissions, PermissionTypes.read, PermissionConcerns.CellNass_Operators))
        } as ISchemaChild,
        { 
            entityName: EntityNames.volumes, 
            displayName: "Volumes", 
            cantView: true, 
            viewType: EntityViewTypes.writableList,
            canAdd: ((ctx) => hasPermission(ctx.permissions, PermissionTypes.write, PermissionConcerns.Manage_Volumes)),
            permissionToView: ((ctx) => hasPermission(ctx.permissions, PermissionTypes.read, PermissionConcerns.Volumes))
        } as ISchemaChild,
        { 
            entityName: EntityNames.deliveryMethods, 
            displayName: "Delivery methods", 
            cantView: true, 
            viewType: EntityViewTypes.writableList,
            canAdd: ((ctx) => hasPermission(ctx.permissions, PermissionTypes.write, PermissionConcerns.Manage_Delivery_Methods)),
            permissionToView: ((ctx) => hasPermission(ctx.permissions, PermissionTypes.read, PermissionConcerns.Delivery_Methods))
        } as ISchemaChild,
        { 
            entityName: EntityNames.caseMaterialTypes, 
            displayName: "Material types", 
            cantView: false, 
            viewType: EntityViewTypes.writableList, 
            canAdd: ((ctx) => hasPermission(ctx.permissions, PermissionTypes.write, PermissionConcerns.Manage_Case_Material_Types)), 
            enableFilters: false,
            permissionToView: ((ctx) => hasPermission(ctx.permissions, PermissionTypes.read, PermissionConcerns.Manage_Case_Material_Types) || hasPermission(ctx.permissions, PermissionTypes.write, PermissionConcerns.Manage_Case_Material_Types))
        } as ISchemaChild,
        { 
            entityName: EntityNames.locations, 
            displayName: "Locations", 
            cantView: false, 
            viewType: EntityViewTypes.list, 
            canAdd: ((ctx) => hasPermission(ctx.permissions, PermissionTypes.write, PermissionConcerns.Manage_Locations)), 
            enableFilters: true,
            permissionToView: ((ctx) => hasPermission(ctx.permissions, PermissionTypes.write, PermissionConcerns.Manage_Locations))
        } as ISchemaChild,
    ],
}
